/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import { checkValidEmailAddress } from '../../../shared/constants/Constants';
import AppButton from '../../../shared/components/app-button/AppButton';
import HotelEmailContent from './HotelEmailContent';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';

function HotelEmailShareModal({ onSend, shortListedHotels, searchRequest }) {
  const [showInput, setShowInput] = useState(true);
  const [showBreakup, setShowBreakup] = useState(true);
  const [senderEmail, setSenderEmail] = useState('');
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [validationError, setValidationError] = useState(false);

  const handleSendEmail = () => {
    setShowInput(false);
    if (senderEmail === '' || checkValidEmailAddress(senderEmail)) {
      setValidationError(true);
      setShowInput(true);
      return false;
    }

    setTimeout(() => {
      const content = document.getElementById('hotelEmailContent').innerHTML;
      onSend(senderEmail, content);
    }, 500);
  };
  return (
    <div>
      <div className="d-flex align-items-center gap-3 mb-1">
        <AppRadioInput
          id="true"
          name="showBrakup"
          labelText="With Fare"
          value=""
          onChange={() => setShowBreakup(true)}
          checked={showBreakup}
        />
        <AppRadioInput
          id="false"
          name="showBrakup"
          labelText="Without Fare"
          value=""
          onChange={() => setShowBreakup(false)}
          checked={!showBreakup}
        />
      </div>
      <Row className="spacing-16 my-2">
        <Col lg={8} md={8} sm={6} xs={12}>
          <AppTextInput
            label="Email to share"
            name="toEmail"
            placeholderText=""
            value={senderEmail}
            onChange={(e) => setSenderEmail(e.target.value)}
            errorText={validationError && 'Enter Email Address'}
          />
          {checkValidEmailAddress(senderEmail) &&
            validationError &&
            senderEmail !== '' && (
              <small className="app-error-text">Enter Valid Email</small>
            )}
        </Col>
        <Col lg={4} md={4} sm={6} xs={12}>
          <AppNumberInput
            name="markUpToBeAdded"
            label="Markup"
            value={markUpToBeAdded}
            onChange={(d) => setMarkupToBeAdded(d)}
          />
        </Col>
        <Col lg={12} md={12} sm={12} xs={12}>
          <div className="overflow-auto hide-in-mobile">
            <HotelEmailContent
              hotelList={shortListedHotels}
              searchQuery={searchRequest.searchQuery}
              showInput={showInput}
              showBreakup={showBreakup}
              markUpToBeAdded={markUpToBeAdded}
            />
          </div>
        </Col>
        <Col
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="d-flex justify-content-end"
        >
          <div>
            <AppButton
              btnText="Send Email"
              onClick={handleSendEmail}
              variant="primary"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

HotelEmailShareModal.propTypes = {
  onSend: PropTypes.func.isRequired,
  shortListedHotels: PropTypes.array.isRequired,
  searchRequest: PropTypes.object.isRequired,
};

export default HotelEmailShareModal;
